<template>
  <div v-click-outside="onClickOutside" class="editor-select">
    <div
      class="editor-select__value"
      :class="{ 'editor-select__value--opened': open }"
      @click="open = !open"
    >
      {{ optionText ? value[optionText] : value }}
      <DropdownIcon />
    </div>
    <div v-show="open" class="editor-select__dropdown">
      <div
        v-for="option in options"
        :key="optionKey ? option[optionKey] : option"
        class="editor-select__option"
        :class="{
          'editor-select__option--active': optionKey
            ? value[optionKey] === option[optionKey]
            : value === option
        }"
        @click="
          open = false;
          $emit('input', option);
        "
      >
        {{ optionText ? option[optionText] : option }}
      </div>
    </div>
  </div>
</template>

<script>
import DropdownIcon from '@/components/Icons/DropdownIcon';
import vClickOutside from 'v-click-outside';

export default {
  name: 'Select',
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    DropdownIcon
  },
  props: {
    value: {
      type: [String, Number, Date, Object],
      required: true
    },
    options: {
      type: Array,
      default: () => []
    },
    optionKey: {
      type: String,
      default: undefined
    },
    optionText: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      open: false
    };
  },
  methods: {
    onClickOutside() {
      this.open = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/style/utils';

.editor-select {
  position: relative;

  &__value {
    cursor: pointer;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    svg {
      transition: all 0.5s ease;
    }

    &--opened {
      svg {
        transform: rotate(180deg);
      }
    }
  }

  &__dropdown {
    position: absolute;
    z-index: 1;
    left: -16px;
    top: 34px;
    background-color: white;
    border-radius: 4px;
    padding: 20px;
    width: fit-content;
    color: $ui-black;
    box-shadow: 0 4px 10px rgba(43, 45, 52, 0.12);
  }

  &__option {
    cursor: pointer;
    margin-bottom: 16px;
    font-size: 14px;

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      color: $ui-blue-accident;
    }

    &--active {
      color: $ui-blue-accident;
    }
  }
}
</style>
